import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';
import { MapSet, mapSetSchema } from '../schemas/map-set.schema';

/**
 * Creates a new Map Set
 * @param mapSet The Map Set being created
 * @returns Data object containing the created Map Set
 */
export function postMapSets(this: unknown, mapSet: Partial<MapSet>) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).mapSetsUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(mapSet),
      })
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: mapSetSchema,
      })
    )
  );
}
